import { MaxResidualizedMsrpAppliedField, useMaxResidualizedMsrpField } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { StackedValue } from '../../../ScenarioGrid.style';
import { ScenarioManualEditMarker } from '../../ScenarioManualEditMarker';
import { ScenarioRow } from '../../ScenarioRow';

export const MrmRow = () => {
    const { label, overrideIndicatorProps, inputProps } = useMaxResidualizedMsrpField({ tab: DealTabs.SUMMARY });
    const inputId = useScenarioCellId('mrm');

    return (
        <ScenarioRow rowKey="mrm" label={label} inputId={inputId}>
            <StackedValue>
                <ScenarioManualEditMarker {...overrideIndicatorProps}>
                    <NumericInput {...inputProps} id={inputId} displayLabel={false} />
                </ScenarioManualEditMarker>
                <MaxResidualizedMsrpAppliedField />
            </StackedValue>
        </ScenarioRow>
    );
};
